(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2060],{

/***/ 42060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content067": function() { return /* binding */ Content067; },
  "default": function() { return /* binding */ Content067_Content067; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/components/LazyRenderingButton/index.js + 3 modules
var LazyRenderingButton = __webpack_require__(41141);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
// EXTERNAL MODULE: ./src/components/widgets/content/Content067/Content067.module.scss
var Content067_module = __webpack_require__(20090);
var Content067_module_default = /*#__PURE__*/__webpack_require__.n(Content067_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/widgets/content/Content067/Items/Items.module.scss
var Items_module = __webpack_require__(3612);
var Items_module_default = /*#__PURE__*/__webpack_require__.n(Items_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content067/Items/Items.jsx





var Items = function(param) {
    var items = param.items;
    var limit = (0,LazyRenderingButton/* useLazyRenderingState */.vO)().limit;
    var slicedItems = (0,react.useMemo)(function() {
        return items.slice(0, limit);
    }, [
        items,
        limit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Items_module_default()).items,
        children: slicedItems.map(function(item) {
            var ref, ref1;
            var ref2;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                directory: "events",
                slug: item.slug,
                className: (Items_module_default()).link,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Items_module_default()).item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Items_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                        className: (Items_module_default()).category,
                                        color: "grey",
                                        uppercase: true,
                                        children: (ref2 = (ref = item.eventCategories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref2 !== void 0 ? ref2 : ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                        className: (Items_module_default()).title,
                                        appearance: "bold",
                                        children: item.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                className: (Items_module_default()).date,
                                appearance: "bigger",
                                children: item.eventTimeDescription
                            })
                        ]
                    })
                })
            }, item.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content067/Items/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content067/Content067.jsx








var Content067 = function(param) {
    var payload = param.payload;
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("067", payload.id);
    var events = (0,PageData/* useCollectedData */.M)(instanceId, [
        {
            name: "events",
            defaultValue: []
        }, 
    ]).events;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.caption) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var buttonText = (ref2 = payload === null || payload === void 0 ? void 0 : payload.buttonText) !== null && ref2 !== void 0 ? ref2 : "";
    if (events.length < 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content067_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Content067_module_default()).top,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                            className: (Content067_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                            value: description,
                            className: (Content067_module_default()).description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content067_module_default()).content,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyRenderingButton/* LazyRenderingProvider */.Bv, {
                        size: events.length,
                        initialLimit: 2,
                        incrementBy: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Items, {
                                items: events
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LazyRenderingButton */.WJ, {
                                appearance: "grey",
                                buttonText: buttonText
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Content067_Content067 = (Content067);


/***/ }),

/***/ 20090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content067_wrapper___mgtL","top":"Content067_top__KDHHK","title":"Content067_title__UiSL0","description":"Content067_description__KUTqS"};

/***/ }),

/***/ 3612:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"items":"Items_items__j6Ng4","item":"Items_item__eLsTt","content":"Items_content__YUQTF","link":"Items_link__wD_TL","title":"Items_title__lu58h","category":"Items_category___2nQx","date":"Items_date__u9UqD"};

/***/ })

}]);